/**
 * 选择题
 */
import QuestionSelect from './view';

export default QuestionSelect;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/select/index.js